<template>
  <list-item
    :booking="booking"
    :link="{ name: 'requests.show', params: { id: booking.id, draft: this.bookingIsDraft} }"
  >
    <template v-slot:pill>
       <div v-if="$userIsTalent || $userIsManager" class="inline-flex">
        <span class="label label-success" v-if="talentHasAppliedForBooking">
          {{ $declineModuleEnabled ? $t('Applied') : 'Accepted' }}
          <template v-if="$userIsManager">({{ talentAppliedForBooking }})</template>
        </span>
        <span class="label label-danger" v-else-if="talentHasDeclinedBooking">
          Declined
          <template v-if="$userIsManager">({{ talentDeclinedBooking }})</template>
        </span>
        <template v-else-if="talentHasMixedResponse">
          <span class="label label-success">{{ $declineModuleEnabled ? $t('Applied') : 'Accepted' }} ({{ talentAppliedForBooking }})</span>
          <span class="label label-danger">Declined ({{ talentDeclinedBooking }})</span>
        </template>
      </div>
    </template>

    <template v-slot:title>
      <span>{{ bookingName }}</span>
      <span v-if="$userIsAdmin"> - {{ bookingDateCreated | date($user.date_format_preference) }}</span>
      <span class="small" v-if="bookingIsDraft">&ndash; (Draft)</span>
      <span class="small" v-if="bookingIsVetting">&ndash; (Pending)</span>
    </template>

    <template v-slot:bids>
      <span v-if="$userIsAdmin && bookingHasTalentResponses" class="list-item__bids">
        {{ booking.talent_response_count }}
      </span>
    </template>

    <template v-slot:categories>
      <div v-if="booking.opportunities.length" class="flex flex-wrap">
        <span v-for="app in booking.opportunities" :key="app.id" class="label label-info">{{ app.name }}</span>
      </div>
    </template>

    <template v-if="$userIsAdmin && bookingHasTalentResponses" v-slot:bids>
      <span data-test-id="numberBids" class="list-item__bids">
        {{ booking.talent_response_count }}
      </span>
    </template>

    <template v-slot:status>
      <div class="spacer-b-2" >
        <span class="label label-default" v-if="bookingIsCancelled">Cancelled</span>
        <span class="label label-info" v-else-if="bookingIsWithdrawn">Withdrawn</span>
        <span class="label label-danger" v-else-if="bookingIsDeclined">Declined</span>
        <span class="label label-danger" v-else-if="bookingIsContextuallyUnsuccessful">Unsuccessful</span>
        <span class="label label-success" v-else-if="bookingIsCompleted">Completed</span>
        <span class="label label-danger" v-else-if="bookingHasExpired">Expired</span>
        <span class="label label-danger" v-if="booking.urgent">Urgent</span>
      </div>
    </template>

    <template v-slot:hero v-if="userCanSeeBudget" >
      <template v-if="$userIsTalent || $userIsManager">
        <template v-if="booking.local_currency">
          {{ booking.local_currency_budget_per_star_as_user_rate | abbreviatedCurrency(booking.local_currency) | nullable }}
        </template>
        <template v-else>
          {{ booking.budget_per_star_as_user_rate | abbreviatedCurrency(booking.currency) | nullable }}
        </template>
      </template>
      <span v-else-if="bookingGrandTotalBudget">{{ bookingGrandTotalBudget | abbreviatedCurrency(booking.local_currency ? booking.local_currency : booking.currency) | nullable }}</span>
      <span v-else>View</span>
    </template>

    <template v-slot:admin>
      <div class="spacer-b-1 flex flex-row" v-if="booking.local_currency">
        <i class="fa fa-info-circle spacer-r-1"></i>
        <span>Estimated conversion to {{ booking.local_currency }}. Actual amount may differ due to fluctuating conversion rates.</span>
      </div>
      <meta-item v-if="bookingIsNotPublic && $userIsAdmin" icon="eye-slash">Hidden</meta-item>
      <meta-item v-if="$userIsAdmin">
        <template v-slot:key>Vetted:</template>
        {{ bookingVettedDate | date($user.date_format_preference) }}
      </meta-item>
    </template>

  </list-item>
</template>

<script>
import { helpers, talentHelpers } from 'mixins/bookings'
import ListItem from '../../list/ListItem'
import MetaItem from '../../list/meta/MetaItem'
import moment from 'moment-timezone'

export default {
  mixins: [helpers, talentHelpers],
  components: {
    ListItem,
    MetaItem
  },
  computed: {
    bookingVettedDate () {
      return moment.utc(this.booking.vetted_date).local()
    },
    bookingDateCreated () {
      return moment.utc(this.booking.created_at).local()
    }
  },

  props: {
    booking: {
      type: Object,
      required: true
    }
  }
}
</script>
